<template>
    <div class="vipOpenBox">
       <div>
           <div class="vipOpenTit">
               <h3>版权家·会员开通</h3>
               <ul>
                   <li class='dingdan'>1.填写订单</li>
                   <li :class='one==1?"zhifu":"zhifu_yellow"'>2.核对订单及支付</li>
                   <li :class='one==3?"chenggong_yellow":"chenggong"'>3.支付成功</li>
               </ul>
           </div>
           <div class="vipOpenInfo">
               <div class="vipflex">
                <img class="vipphoto" :src="userInfoObj && userInfoObj.photo"/>
                <div class="vipname">
                    <p class="vipnamep1">{{userInfoObj && userInfoObj.nickName}}</p>
                    <p class="vipnamep2">{{userInfoObj && userInfoObj.mobilePhone}}</p>
                </div>
               </div>
               <a class="vipNoYuan" v-if='userInfoObj && userInfoObj.vipFlag ==1'>会员有效期至{{userInfoObj.vipEndDate.split(" ")[0]}}</a>
               <a class="vipNoYuan" v-else-if='userInfoObj && userInfoObj.vipFlag ==2'>会员有效期至{{userInfoObj.vipEndDate.split(" ")[0]}}</a>
               <a class="vipNoYuan" v-else>当前未开通会员</a>
           </div>
           <div class="vipOpenType" v-if="one == 1">
               <div class="vipType">
                   <p class="viptitle">选择开通会员类型</p>
                   <div class="viptop">
                       <div v-for="(item,index) in showKtList" :key="index" @click="selectChange(item,index)"
                       :class="active==index?'openVipBg vipSelect':'openVipBg'" :style="{background: 'url('+item.bigurl+') no-repeat', backgroundSize: '100% 100%'}">
                            <img :src="item.sizeurl" class="vipcont-1" />
                            <span>¥{{item.value}}</span>
                            <p class="viptop_1">
                                <span>{{item.title}}</span>
                                <span>1年有效期</span>
                            </p>
                            <img class="tempimg" src="./images/chenck_vip.png" />
                        </div>
                   </div>
               </div>
               <div class="couponType">
                   <p class="viptitle">使用优惠券</p>
                   <div class="vipmiddle">
                       <!-- <div class="vipmiddle1" v-if="options3 && options3.length>0" v-for="(item,index) in options3" :key='index'>
                            <img class="vipmiddleimg" @click="twSelect(item,index)" :src="activemd == index?selectImg:selectNoImg" />
                            <p class="vipmiddlep">
                                <span>¥</span>
                                <span>{{item.discountAmount.substring(0,item.discountAmount.lastIndexOf("元"))}}</span>
                            </p>
                            <p class="vipmiddleb">
                                <span>{{item.productDesc == null ? '适用铜牌/银牌/金牌会员购买':item.productDesc}}</span>
                                <span>有效时间：{{item.validTime}}</span>
                            </p>
                        </div> -->
                        <div class="vipmiddle1" v-if="options3 && options3.length>0" v-for="(item,index) in options3" :key='index'>
                            <img :src="item.ifSelect?selectImg:selectNoImg" class="vipmiddleimg" @click="twSelect(item,index) "/>
                            <p class="vipmiddlep">
                                <span class="fh" v-if="item.category=='0'">¥</span>
                                <span class="price" v-if="item.category=='0'">{{parseFloat(item.discountAmount)}}</span>
                                <span class="price" v-if="item.category=='1'">{{item.discount}}</span>
                                <span class="discount_text" v-if="item.category=='1'">折</span>
                            </p>
                            <p class="vipmiddleb">
                                <span>{{item.productDesc == null ? '适用铜牌/银牌/金牌会员购买':item.productDesc}}</span>
                                <span>有效时间：{{item.validTime}}</span>
                            </p>
                        </div>
                        <div v-if="options3.length==0">暂无可用优惠券</div>
                   </div>
               </div>
               <div style="clear: both;">
                   <p class="viptitle">使用红包</p>
                   <div class="viptit3">
                       <!-- <img src="./images/checked.png"/> -->
                       <img @click="isHongbao" :src="isUseHongbao ? selectImg:selectNoImg" />
                       <span>红包余额：¥{{hbamount}}</span>
                   </div>
               </div>
           </div>
           <div class="viptwo" v-if="one == 2">
               <p class="viptitle">订单详情</p>
               <div class="viptwocontent">
                   <div class="viptwocontentp">
                       <p>时长：</p>
                       <p>1年</p>
                   </div>
                   <div class="viptwocontentp">
                       <p>应付金额：</p>
                       <p>¥{{orderInfo && Number(orderInfo.needToPay)}}</p>
                   </div>
<!--                   <div class="viptwocontentp">
                       <p>到期时间：</p>
                       <p>{{resTime}}</p>
                   </div>-->
                   <div class="viptwocontentp">
                       <p>订单编号：</p>
                       <p>{{orderInfo && orderInfo.orderNo}}</p>
                   </div>
                   <div class="viptwocontentp">
                       <p>订单时间：</p>
                       <p>{{orderInfo && orderInfo.createDate}}</p>
                   </div>
               </div>
               <p style="margin-bottom:13px;" class="viptitle">支付方式</p>
                <div class="vipBtocontent">
                    <div @click="cobSelect(1)" :class="actcob == 1 ? 'viptwocob vipactiv':'viptwocob'">
                        <img class="viptwocob1" src="./images/qianbao.png" />
                        <div class="viptwocob2">
                            <p class="yuePayBox">余额支付<a v-if='orderInfo && (Number(amount)-(Number(orderInfo.needToPay))<0) && isYePay=="是"' @click='goCz'>去充值</a></p>
                            <p>当前余额：{{amount}}元</p>
                        </div>
                    </div>
                    <div @click="cobSelect(2)" :class="actcob == 2 ? 'viptwocob vipactiv':'viptwocob'">
                        <img style="width:119px;height:32px;margin-left:46px;" src="./images/weixin.png" />
                    </div>
                    <div @click="cobSelect(3)" :class="actcob == 3 ? 'viptwocob vipactiv':'viptwocob'">
                        <img style="width:91px;height:32px;margin-left:60px;" src="./images/zfb.png" />
                    </div>
                </div>
                <div class="vipTwoFooter" >
                    <div>实付金额：</div><!-- {{payWayPrice}} -->
                    <div class="tempdif">¥{{orderInfo && Number(orderInfo.needToPay)}}</div>
                    <input style="margin-top:38px;background:#DFDFDF;color:#A5A5A5;cursor: no-drop;" v-if='Number(amount)-(Number(orderInfo.needToPay)/100)<0 && isYePay=="是"' class="vipbtn" tyle="button" value="立即支付"/>
                    <input style="margin-top:38px;" v-else @click="gopay()" class="vipbtn" tyle="button" value="立即支付" />
                    <!-- v-if='Number(amount)-(Number(orderInfo.payAmount)/100)<0' -->
                </div>
           </div>
           <div class="vipthree" v-if="one == 3">
               <img src="./images/paysyccess.png" />
               <p>支付成功</p>
               <div>
                   <input style="background: #ebebeb;border-radius:20px;" class="vipbtn" tyle="button" value="返回首页" @click="goIndex"/>
                   <input style="margin-left:20px;border-radius:20px;" class="vipbtn" tyle="button" value="去使用" @click="goUse"/>
               </div>
           </div>
       </div>
       <div class="vipFooter" v-if="one == 1">
           <div class="vipFooterContent">
                <p class="vipFooter1">
<!--                    <span>温馨提示：</span>
                    <span>购买后会员到期日为{{resTime}}</span>-->
                </p>
                <div class="vipFooter2">
                    <p class="vipFooter2_1" style="padding-right:28px;margin-right:28px;border-right:1px solid #e5e5e5;">
                        <span>订单金额：<i>¥{{snoAmount}}</i></span>
                        <!-- <span>优惠金额：<i>¥{{couponAmount}}</i></span> -->
                        <span>优惠金额：<i>¥{{Number(couponAmount)-Number(snoAmount)<0 ? Number(couponAmount).toFixed(2) :Number(snoAmount).toFixed(2)}}</i></span>
                    </p>
                    <p class="vipFooter2_1" style="margin-right:122px;">
                        <span style="margin-bottom:0px;">红包抵扣：<i>¥{{Number(hongbaoDikouStrng)>0?(hongbaoDikouStrng).toFixed(2):0}}</i></span>
                        <!-- <span style="margin-bottom:0px;">红包抵扣：<i>¥{{Number(isUseHongbaoKc)-Number(snoAmount)<0 ? isUseHongbaoKc :snoAmount}}</i></span> -->
                        <span>实付金额：<i style="font-size: 20px;color:#f96509;font-weight:600">¥{{(Number(snoAmount)-Number(couponAmount)-Number(hongbaoDikouStrng))>0?(Number(snoAmount)-Number(couponAmount)-Number(hongbaoDikouStrng)).toFixed(2):0}}</i></span>
                    </p>
                    <div>
                        <input class="vipbtn" tyle="button" value="提交订单" @click="submitNo"/>
                    </div>
                </div>
            </div>
       </div>
       <div class="mydiag" v-if="showWxDialog">
           <div class="mydiag_content">
               <div class="mydiag_title">
                   <div>微信支付</div>
                   <img @click="closeWx()" src="./images/close.png" />
               </div>
               <div class="mydiag_img">
                   <div class="mydiag_img1">使用微信扫一扫</div>
                   <img style="width:228px;height:226px;" :src="wxCode && wxCode"/>
                   <input style="margin-top:54px;" class="vipbtn1" tyle="button" value="返回" @click="closeWx()"/>
               </div>
           </div>
       </div>
       <div class="mydiag" v-if="showZfbDialog">
           <div class="mydiag_content">
               <div class="mydiag_title">
                   <div>支付宝支付</div>
                   <img @click="closeZfb()" src="./images/close.png" />
               </div>
               <div class="mydiag_img">
                   <div class="mydiag_img1">使用支付宝扫一扫</div>
                   <img style="width:228px;height:226px;" :src="zfbCode && zfbCode" />
                   <input style="margin-top:54px;" class="vipbtn1" tyle="button" value="返回" @click="closeZfb()"/>
               </div>
           </div>
       </div>
    </div>  
</template>

<script>
import {_findIndexPageShowNewNew,userInfo} from "@/api/index";
//   import {postMemberApplication} from '@/api/staticPage'
import { orderCouponList ,_getFindOne,payOrderSubmit,_findOne,couponList,_orderPay,_countOrder} from "@/api/wallet.js";
import Cookies from "js-cookie";
import $ from 'jquery';
export default {
    name:'openVip',
    components:{
    },
    data() {
        return {
            newData:[], // 目标数组
            newObj:{},
            midArray:[],
            active:null,
            selectImg:require('./images/checked.png'),
            selectNoImg:require('./images/noChecked.png'),
            activemd:null,
            one:1,
            actcob:1,
            showZfbDialog:false,
            showWxDialog:false,
            isUseHongbao:true,
            showKtList:[],
            vipList:[],
            couponArr:[],
            hbamount:0,
            userInfoObj:null,
            couponAmount:0,
            snoAmount:0,
            snoCode:"",
            resTime:"",
            isUseHongbaoKc:0,
            orderInfo:null,
            amount:0,
            wxCode:"",
            wxId:"",
            zfbCode:"",
            zfbId:"",
            pandShow:0,
            vipTypeCode:null,
            payWayPrice:0,
            value11: [],
            options3:[],
            couponSnapshotIdArr:"",
            isYePay:"是",
            hongbaoDikouStrng:0,
        }
    },
    created(){
        // console.log(this.$route.query.type)
    },
    methods: {
        goIndex(){
            this.$router.push({
                name: 'home_index'
            });
        },
        goUse(){
            this.$router.push({
                path: '/look-member'
            });
        },
        valChange(opVal,d){
            console.log(opVal)
            if(opVal.isDx ==0){

            }
            // console.log(d)]
            // this.value11 = opVal
            // const len = this.value11.length;
            // if(this.options3[0].options.some(item=>item.value==this.value11[len-1])){
            //     console.log(1)
            //     this.value11.splice(0,len-1)
            // }else if(this.options3[1].options.some(item=>item.value==this.value11[len-1])){
            //     console.log(2)
            //     this.value11 = this.value11.filter(opVal=>!this.options3[0].options.some(item=>item.value==opVal))
            // }
            // console.log(this.value11)
        },
        selectChange(item,index){
            console.log(item)
            this.snoAmount = item.value;
            this.snoCode = item.code;
            this.active = index;
            this.vipTypeCode = item.code;
            this.$nextTick(()=>{
                this.getCouponList()
            })
        },
        twSelect(item,index){
            console.log(item)
            let lastArray = this.options3
            let newData = []; // 目标数组
            let newObj = {};
            let midArray = []
            if(item.flag == '2'){
                for(let j in lastArray){
                    lastArray[j].ifSelect = false
                }
                for(let i in lastArray){
                    if(index == i){
                        if(lastArray[i].ifSelect == true){
                            lastArray[i].ifSelect = false
                        }else{
                            lastArray[i].ifSelect = true
                        }
                    }
                }
            } else if(item.flag == '1'){
                if(item.categoryFlag == 2){
                    if(item.ifSelect == true){
                        item.ifSelect == false
                    }else{
                        for(let k in lastArray){
                            if(lastArray[k].ifSelect == true && lastArray[k].categoryFlag == 2){
                                lastArray[k].ifSelect = false
                            }
                        }
                    }
                }
                for(let j in lastArray){
                    if(lastArray[j].flag == '2'){
                        lastArray[j].ifSelect = false
                    }
                }
                if(this.newData.length > 0){
                    for(let y in this.newData){
                        if(this.newData[y].discountCouponId == item.discountCouponId){
                            if(item.ifSelect == false){
                                if(this.newData[y].number > Number(item.maxNumber)){
                                    console.log('超市111111111111')
                                    return false;
                                }
                            } 
                        }
                    }
                }
                for(let i in lastArray){
                    if(index == i){
                        if(lastArray[i].ifSelect == true){
                            lastArray[i].ifSelect = false
                        }else{
                            lastArray[i].ifSelect = true
                        }             
                    }
                }
                
            } else {
                toast('优惠券异常')
            }
            for(let m in lastArray){
                if(lastArray[m].ifSelect == true){
                    midArray.push(lastArray[m])
                    this.midArray = midArray
                }
            }
            if(midArray.length > 0){
                midArray.forEach((el, i) => {
                    if (!newObj[el.discountCouponId]) {
                        el.number = 1
                        newData.push(el);
                        newObj[el.discountCouponId] = el.discountCouponId;
                        this.newObj = newObj
                        this.newData = newData
                    } else {
                        newData.forEach(el => {
                            if (el.discountCouponId == midArray[i].discountCouponId) {
                                el.number += 1;
                                if(el.number > Number(el.maxNumber)){
                                    for(let t in lastArray){
                                        if(index == t){
                                            lastArray[t].ifSelect = false
                                        }
                                    }
                                    toast('超出了最大选择范围')
                                    return false;
                                }
                                // el.txtArr = [...el.txtArr, ...testOld[i].txtArr]; // es6语法
                            }
                        })
                        this.newData = newData
                    }
                });
            }
            
            this.options3 = lastArray
            this.options3 = this.options3.slice(0)
            // this.couponAmount = item.discountAmount.substring(0,item.discountAmount.lastIndexOf("元"))
            // this.activemd = index
            let aaa = 0,bb=0;
            let idArr = [];
            for(let i in this.options3){
                if(this.options3[i].ifSelect){
                    if(this.options3[i].categoryFlag == 2){
                        bb = Number(this.snoAmount) - (Number(this.snoAmount)*Number(this.options3[i].discount/10))
                    }else{
                        aaa+=Number(parseFloat(this.options3[i].discountAmount))
                    }
                    // aaa+=Number(parseFloat(this.options3[i].discountAmount))
                    idArr.push(this.options3[i].couponSnapshotId)
                }
            }
            this.couponAmount = aaa + bb;
            this.couponSnapshotIdArr = idArr.join(',');
            this.getFindOne(this.couponAmount)
        },
        cobSelect(num){
            this.actcob = num
            if(num == 2){
                this.pandShow = 0;
                this.isYePay = "否"
                this.payWayPrice = this.orderInfo.needToPay
                // this.showWxDialog =true;
                // this.wxCodePay()
            }
            if(num ==3){
                this.pandShow = 1;
                this.isYePay = "否"
                this.payWayPrice = this.orderInfo.needToPay
                // this.showZfbDialog = true;
                // this.zfbCodePay()
            }
            if(num == 1){
                this.isYePay = "是"
                // this.payWayPrice = (this.orderInfo.payAmount)/100
                if(Number(this.amount) >= Number(this.orderInfo.needToPay)){
                    this.payWayPrice = 0
                }else{
                    this.payWayPrice = Number(this.orderInfo.needToPay) - Number(this.amount)
                }
            }
            this.actcob = num
        },
        //生成二维码
        wxCodePay(payStr){
            const data={
                orderNo:this.orderInfo.orderNo,
                payWay:payStr
            }
            _orderPay(data).then(res=>{
                if(res.code ==200){
                    this.wxCode = res.result.qrCode;
                    this.wxId=res.result.id;
                    clearInterval(this.clearTimer);
                    this.clearTimer = setInterval(this.getPayStatus, 2000);
                }else{
                    toast(res.message)
                }
            })
        },
        zfbCodePay(payStr){
            const data={
                orderNo:this.orderInfo.orderNo,
                payWay:payStr
            }
            _orderPay(data).then(res=>{
                if(res.code ==200){
                    this.zfbCode = res.result.qrCode;
                    this.zfbId=res.result.id;
                    clearInterval(this.clearTimer);
                    this.clearTimer = setInterval(this.getPayStatus, 2000);
                }else{
                    toast(res.message)
                }
            })
        },
        yezfCodePay(payStr){
            // $("#yueButton").attr("disabled","disabled");
            let _this = this;
            const data={
                orderNo:this.orderInfo.orderNo,
                payWay:payStr
            }
            // const val={
            //     registerId:userInfos && userInfos.id?userInfos.id:'',
            //     subBizType:this.orderInfo.subBizType,
            //     payWay:'ewallet',
            // }
            _orderPay(data).then(res => {
                if(res.code==200){
                    console.log('获取的余额的值',res)
                    toast("支付成功");
                    _this.one =3;
                    userInfo().then(userRes=>{
                        if (res.code==200) {
                            Cookies.set("userInfo", JSON.stringify(userRes.result));
                            _this.setStore("userInfo", userRes.result);
                            _this.userInfoObj = userRes.result
                        }
                    })
                    //获取是否有未支付的订单
                    _countOrder().then(res=>{
                        if(res.code == 200){
                            console.log(res)
                            Cookies.set("countOrderNum",res.result);
                            _this.setStore("countOrderNum", res.result);
                        }
                    })
                }
                // else if(res.code==500){
                //     this.yenoMoney=!0;
                //     $("#yueButton").removeAttr("disabled");
                // }else{
                //     toast(res.message)
                //     $("#yueButton").removeAttr("disabled");
                // }
            });
        },
        //去充值
        goCz(){
            this.$router.push({
                name: "wallet"
            });
            let _this = this;
            //获取是否有未支付的订单
            _countOrder().then(res=>{
                if(res.code == 200){
                    console.log(res)
                    Cookies.set("countOrderNum",res.result);
                    _this.setStore("countOrderNum", res.result);
                }
            })
        },
        //查询支付状态
        getPayStatus(){
            let _this = this
            if(this.pandShow == 0){
                this.getRequest("/registerVipMemberApplication/get/"+this.wxId).then(res => {
                    if(res.code==200){
                        if (res.result.payStatus == "paid") {
                            clearInterval(_this.clearTimer);
                            _this.showWxDialog = false
                            toast("支付成功");
                            _this.one = 3;
                            userInfo().then(res=>{
                                if (res.code==200) {
                                    Cookies.set("userInfo", JSON.stringify(res.result));
                                    _this.setStore("userInfo", res.result);
                                    _this.userInfoObj = res.result
                                    // let vipData=res.result.vipEndDate.split(' ')[0];
                                    // _this.$emit('updateVipData',vipData);
                                    // _this.$emit('fatherModal');
                                }
                            })
                            //获取是否有未支付的订单
                            _countOrder().then(res=>{
                                if(res.code == 200){
                                    console.log(res)
                                    Cookies.set("countOrderNum",res.result);
                                    _this.setStore("countOrderNum", res.result);
                                }
                            })
                        }else{
                            //获取是否有未支付的订单
                            _countOrder().then(res=>{
                                if(res.code == 200){
                                    console.log(res)
                                    Cookies.set("countOrderNum",res.result);
                                    _this.setStore("countOrderNum", res.result);
                                }
                            })
                        }
                    }
                });
            }
            if(this.pandShow == 1){
                this.getRequest("/registerVipMemberApplication/get/"+this.zfbId).then(res => {
                    if(res.code==200){
                        if (res.result.payStatus == "paid") {
                            clearInterval(_this.clearTimer);
                            _this.showZfbDialog = false
                            toast("支付成功");
                            _this.one = 3;
                            userInfo().then(res=>{
                                if (res.code==200) {
                                    Cookies.set("userInfo", JSON.stringify(res.result));
                                    _this.setStore("userInfo", res.result);
                                    _this.userInfoObj = res.result
                                    // let vipData=res.result.vipEndDate.split(' ')[0];
                                    // _this.$emit('updateVipData',vipData);
                                    // _this.$emit('fatherModal');
                                }
                            })//获取是否有未支付的订单
                            _countOrder().then(res=>{
                                if(res.code == 200){
                                    console.log(res)
                                    Cookies.set("countOrderNum",res.result);
                                    _this.setStore("countOrderNum", res.result);
                                }
                            })
                        }else{
                            //获取是否有未支付的订单
                            _countOrder().then(res=>{
                                if(res.code == 200){
                                    console.log(res)
                                    Cookies.set("countOrderNum",res.result);
                                    _this.setStore("countOrderNum", res.result);
                                }
                            })
                        }
                    }
                });
            }
        },
        closeWx(){
            this.showWxDialog = false
            clearInterval(this.clearTimer);
        },
        closeZfb(){
            this.showZfbDialog = false
            clearInterval(this.clearTimer);
        },
        gopay(){
            let _this = this;
            clearInterval(_this.clearTimer);
            let payStr = ''
            if(this.actcob == 1){
                payStr = "Ewallet"
                _this.yezfCodePay(payStr)
            }else if(this.actcob == 2){
                payStr = "WechatPay"
                _this.showWxDialog =true;
                _this.wxCodePay(payStr)
            }else if(this.actcob == 3){
                payStr = "AliPay"
                _this.showZfbDialog = true;
                _this.zfbCodePay(payStr)
            }else{
                toast("请选择支付方式")
            }
        },
        submitNo(){
            console.log(this.snoAmount)
            let _this = this
            let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            if(Number(_this.snoAmount)>0){
                let par={
                    registerId:userInfos && userInfos.id?userInfos.id:'',
                    subBizType:_this.snoCode,
                    payWay: _this.isUseHongbao ? 'redenvelope':'',
                    couponSnapshotIds:_this.couponSnapshotIdArr,
                    useCoupon:_this.couponSnapshotIdArr==""?0:1
                }
                payOrderSubmit(par).then(res=>{
                    if(res.code == 200){
                        if(res.result.orderStatus =='paid'){
                            _this.one = 3;
                            userInfo().then(userRes=>{
                                if (res.code==200) {
                                    Cookies.set("userInfo", JSON.stringify(userRes.result));
                                    _this.setStore("userInfo", userRes.result);
                                    _this.userInfoObj = userRes.result
                                }
                            })
                            
                            // Cookies.set("userInfo", JSON.stringify(userRes.result));
                            // _this.setStore("userInfo", userRes.result);
                            // _this.userInfoObj = userRes.result
                        }else{
                            _this.orderInfo = res.result;
                            _this.one = 2;
                            _this.findOne(res.result);
                            //获取是否有未支付的订单
                            _countOrder().then(res=>{
                                if(res.code == 200){
                                    console.log(res)
                                    Cookies.set("countOrderNum",res.result);
                                    _this.setStore("countOrderNum", res.result);
                                }
                            })
                        }
                    }
                })
                // (Number(snoAmount)-Number(couponAmount)-Number(isUseHongbaoKc))
            }else{
                toast('请选择会员类型')
            }
        },
        isHongbao(){
            this.isUseHongbao = !this.isUseHongbao
            if(this.isUseHongbao){
                this.isUseHongbaoKc = this.hbamount;
                if(Number(this.couponAmount) <= 0){
                    let meiCoupon = Number(this.snoAmount);
                    if(meiCoupon - Number(this.hbamount) >=0){
                        this.hongbaoDikouStrng = this.hbamount
                    }else{
                        this.hongbaoDikouStrng = meiCoupon
                    }
                }else{
                    let useCouponafter;
                    if(Number(this.snoAmount) - Number(this.couponAmount) >=0){
                        useCouponafter = Number(this.snoAmount) - Number(this.couponAmount);
                        if(Number(useCouponafter)- Number(this.hbamount) >=0){
                            this.hongbaoDikouStrng = this.hbamount
                        }else{
                            this.hongbaoDikouStrng = useCouponafter
                        }
                    }else{
                        useCouponafter = Number(this.snoAmount)
                        this.hongbaoDikouStrng = 0;
                    }
                }
            }else{
                this.isUseHongbaoKc = 0;
                this.hongbaoDikouStrng = 0;
            }

        },
        _goPersonOrEnterVip(){
            _findIndexPageShowNewNew().then(res => {
                if (res.code == 200) {
                    this.vipList = []
                    let middleGv = res.result
                    for (let i = 0; i < middleGv.length; i++) {
                        this.vipList.push(middleGv[i])
                    }
                }
                let showKtList = this.vipList.slice(0, 3)
                for (let j = 0; j < showKtList.length; j++) {
                    switch (j) {
                        case 0 :
                            showKtList[j].bigurl = require('./images/vip_tp_bg.png')
                            showKtList[j].sizeurl = require('./images/vip_tongpai.png')
                            break;
                        case 1 :
                            showKtList[j].bigurl = require('./images/vip_by_bg.png')
                            showKtList[j].sizeurl = require('./images/vip_baiyin.png')
                            break;
                        case 2 :
                            showKtList[j].bigurl = require('./images/vip_hj_bg.png')
                            showKtList[j].sizeurl = require('./images/vip_huangjin.png')
                            break;
                        default:
                            break;
                    }
                }
                this.showKtList = showKtList;
                this.$nextTick(() => {
                    this.getVipType(showKtList)
                });
            })
        },
        getFindOne(data){
            let _this = this;
            let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            _getFindOne({registerId:userInfos && userInfos.id?userInfos.id:'',}).then(res=>{
                if(res.code ==200){
                    _this.hbamount = res.result.amount;
                    _this.isUseHongbaoKc = _this.hbamount;
                    if(_this.isUseHongbao){
                        if(data == "noCoupon"){
                            let noCoupon = Number(_this.snoAmount);
                            if(noCoupon - Number(_this.hbamount) >=0){
                                _this.hongbaoDikouStrng = _this.hbamount
                            }else{
                                _this.hongbaoDikouStrng = noCoupon
                            }
                        }else{
                            let useCouponHou;
                            if(Number(_this.snoAmount) - Number(data) >=0){
                                useCouponHou = Number(_this.snoAmount) - Number(data);
                                if(Number(useCouponHou)- Number(_this.hbamount) >=0){
                                    _this.hongbaoDikouStrng = _this.hbamount
                                }else{
                                    _this.hongbaoDikouStrng = useCouponHou
                                }
                            }else{
                                useCouponHou = Number(_this.snoAmount)
                                _this.hongbaoDikouStrng = 0;
                            }
                        }
                    }else{
                        _this.hongbaoDikouStrng = 0;
                    }
                    
                }
            })
        },
        RemoveChinese(strValue) {  
            if(strValue!= null && strValue != ""){  
                var reg = /[\u4e00-\u9fa5]/g;   
                return strValue.replace(reg, "");   
            }  
            else  
                return "";  
        },
        getCouponList(){
            let _this = this;
            _this.$Spin.show();
            let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            const data={
                registerId:userInfo && userInfo.id?userInfo.id:'',
                subBizType:this.vipTypeCode
            }
            orderCouponList(data).then(res => {
                console.log(res)  
                _this.$Spin.hide(); 
                if(res.code=='200'){  
                    if(res.result.length>0){
                        // res.result[0].ifSelect = true
                        let optionMid = res.result
                        for(let i in optionMid){
                            if(optionMid[i].repeat){
                                optionMid[i].flag = '1'
                            } else {
                                optionMid[i].flag = '2'
                            }
                            //是否为折扣券
                            if(optionMid[i].category == 1){
                                optionMid[i].categoryFlag = '2'
                            } else {
                                optionMid[i].categoryFlag = '1'
                            }
                            if(optionMid[i].limitConditions){
                                if(optionMid[i].limitConditions == '无限制'){
                                    optionMid[i].maxNumber = '10000' 
                                }else{
                                    optionMid[i].maxNumber = _this.RemoveChinese(optionMid[i].limitConditions)
                                }
                            }
                            optionMid[i].ifSelect = false
                        }
                        _this.options3 = optionMid;
                        _this.options3[0].ifSelect = true;
                        // console.log(Number(res.result[0].discount)/10)
                        // console.log(Number(_this.snoAmount))
                        // console.log(Number(res.result[0].discount)/10*Number(_this.snoAmount))
                        _this.couponAmount = res.result[0].category ==0? parseFloat(res.result[0].discountAmount):(Number(_this.snoAmount) - Number(res.result[0].discount)/10*Number(_this.snoAmount));
                        console.log(_this.couponAmount)
                        _this.couponSnapshotIdArr = res.result[0].couponSnapshotId;
                        _this.getFindOne(_this.couponAmount);
                    } else{
                        _this.getFindOne("noCoupon");
                        _this.options3 = [];
                        _this.couponAmount = 0
                        _this.couponSnapshotIdArr = []
                    }
                    // _this.options3 = res.result;
                    
                    console.log('获取中转后的数组', _this.options3)
                    // _this.couponAmount = Number(_this.payWayPrice) - Number(_this.isUseHongbaoKc)
                }else{
                    toast(res.message)
                }        
            });
        },
        //余额
        findOne(ress){
            let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            _findOne({registerId:userInfos && userInfos.id?userInfos.id:'',}).then(res => {
                if(res.code==200){
                    this.amount= res.result.amount;
                    if(Number(res.result.amount) >= Number(ress.needToPay)){
                        this.payWayPrice = 0
                    }else{
                        this.payWayPrice = Number(ress.needToPay) - Number(res.result.amount)
                    }
                }
            });
        },
        getEndTime(){
            let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            this.userInfoObj = userInfos;
            if(userInfos && userInfos.vipEndDate != null && userInfos.vipEndDate != ""){
                let a=new Date(userInfos.vipEndDate.split(" ")[0])
                let resYear = a.getFullYear()+1;
                let resMon,resDay
                if(a.getMonth()+1<10){
                    resMon = '0'+(a.getMonth()+1)
                }else{
                    resMon = a.getMonth()+1
                }
                if(a.getDate()<10){
                    resDay = '0'+(a.getDate())
                }else{
                    resDay = a.getDate()
                }
                this.resTime = resYear +'.'+ resMon+'.'+resDay
            }else{
                let b = new Date()
                let bresMon,bresDay
                if(b.getMonth()+1<10){
                    bresMon = '0'+(b.getMonth()+1)
                }else{
                    bresMon = b.getMonth()+1
                }
                if(b.getDate()<10){
                    bresDay = '0'+(b.getDate()-1)
                }else{
                    bresDay = b.getDate()
                }
                this.resTime = b.getFullYear()+1 +'.'+bresMon+'.'+bresDay
            }
        },
        getVipType(data){
            if(this.$route.query.type == undefined){
                this.active =1;
                for(let i in data){
                    if(data[i].title == '银牌会员'){
                        this.vipTypeCode = data[i].code;
                        this.snoAmount = data[i].value;
                        this.snoCode = data[i].code;
                        this.isUseHongbao = true
                        this.$nextTick(() => {
                            this.getCouponList()
                        });
                    }
                }
            }else{
                for(let i in data){
                    if(data[i].title == this.$route.query.type){
                        this.vipTypeCode = data[i].code;
                        this.active =i;
                        this.snoAmount = data[i].value;
                        this.snoCode = data[i].code;
                        this.isUseHongbao = true
                        this.$nextTick(() => {
                            this.getCouponList()
                        });
                    }
                }
            }
        }
    },
    mounted() {
        this.getEndTime()
        this._goPersonOrEnterVip()
        // this.getCouponList()
        clearInterval(this.clearTimer);
        
    },

    watch: {
    }
}
</script>
<style scoped lang="less">  
    .vipOpenBox{
        .vipOpenTit{
            width: 1334px;
            height: 114px;
            margin: 0 auto;
            display: flex;
            padding-top: 40px;
            box-sizing: border-box;
            h3{
                font-size: 28px;
                font-weight: 600;
                color: #282828;
                flex: 1;
            }
            ul{
                width: 447px;
                li{
                    list-style: none;
                    font-size: 14px;
                    color: #666666;
                    float: left;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                }
                .dingdan{
                    background: url('./images/one.png');
                    background-size: 100% 100%;
                    width: 136px;
                    color: #000000;
                }
                .zhifu{
                    width: 175px;
                    background: url('./images/two_dis.png');
                    background-size: 100% 100%;
                }
                .zhifu_yellow{
                    width: 175px;
                    background: url('./images/two.png');
                    background-size: 100% 100%;
                    color: #000000;
                }
                .chenggong{
                    width: 136px;
                    background: url('./images/three_dis.png');
                    background-size: 100% 100%;
                }
                .chenggong_yellow{
                    width: 136px;
                    background: url('./images/three.png');
                    background-size: 100% 100%;
                    color: #000000;
                }
            }
        }
    }
    .vipOpenInfo{
        background:url('./images/bg.png') no-repeat;
        background-size: 100% 100%;
        width: 1334px;
        margin: 0 auto;
        display:flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        margin-bottom:36px;
        .vipflex{
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .vipphoto{
            height:44px;
            width:44px;
            margin-left:30px;
            margin-right:22px;
            border-radius: 50%;
        }
        .vipname{
            display:flex;
            flex-direction:column;
            justify-content: flex-start;
            .vipnamep1{
                font-size: 16px;
                font-family: PingFang SC, PingFang SC-Semibold;
                font-weight: 600;
                color: #fdde91;
            }
            .vipnamep2{
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #fdde91;
            }
        }
        .vipNoYuan{
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: #fdde91;
            margin-right:28px;
        }
    }
    .vipOpenType{
        width: 1334px;
        height:auto;
        opacity: 1;
        border: 1px solid #e5e5e5;
        border-radius: 7px;
        margin:0 auto;
        margin-bottom:45px;
        padding:0px 30px;
        .viptitle{
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            color: #000000;
            margin-top:40px;
            margin-bottom:20px;
        }
        .viptop{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .viptop_1{
                display:flex;
                flex-direction: column;
                span:first-child{
                    font-size: 18px;
                    font-family: PingFang SC, PingFang SC-Semibold;
                    font-weight: 600;
                    color: #7a4f2d;
                }
                span:last-child{
                    font-size: 12px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #7a4f2d;
                    margin-top:7px;
                }
            }
            .openVipBg{
                position:relative;
                cursor:pointer;
                width: 376px;
                height: 100px;
                opacity: 1;
                margin-right:45px;
                // background:url('./images/vip_tp_bg.png') no-repeat;
                background-size: 100% 100%;
                display:flex;
                justify-content: flex-start;
                align-items: center;
                .vipcont-1{
                    width:65px;
                    height:83px;
                    margin-left:25px;
                    margin-top:13px;
                }
                &>span{
                    font-size: 38px;
                    font-weight: 600;
                    margin-left:15px;
                    color: #7a4f2d;
                    width: 140px;
                    display: inline-block;
                    // padding-right:37px;
                    margin-right:29px;
                    border-right:1px solid #cacaca;
                }
            }
            .viptop1{
                position:relative;
                cursor:pointer;
                width: 376px;
                height: 100px;
                opacity: 1;
                margin-right:45px;
                // background:url('./images/vip_tp_bg.png') no-repeat;
                background-size: 100% 100%;
                display:flex;
                justify-content: flex-start;
                align-items: center;
                .vipcont-1{
                    width:65px;
                    height:83px;
                    margin-left:25px;
                    margin-top:13px;
                }
                &>span{
                    font-size: 38px;
                    font-family: PingFang SC, PingFang SC-Semibold;
                    font-weight: 600;
                    margin-left:30px;
                    color: #7a4f2d;
                    padding-right:37px;
                    margin-right:29px;
                    border-right:1px solid #cacaca;
                }
            }
            .viptop2{
                position:relative;
                cursor:pointer;
                width: 376px;
                height: 100px;
                opacity: 1;
                margin-right:45px;
                // background:url('./images/vip_by_bg.png') no-repeat;
                background-size: 100% 100%;
                display:flex;
                justify-content: flex-start;
                align-items:center;
                .vipcont-2{
                    width:64px;
                    height:78px;
                    margin-left:25px;
                    margin-top:15px;
                }
                &>span{
                    font-size: 38px;
                    font-family: PingFang SC, PingFang SC-Semibold;
                    font-weight: 600;
                    margin-left:26px;
                    color: #7a4f2d;
                    padding-right:35px;
                    margin-right:29px;
                    border-right:1px solid #cacaca;
                }
            }
            .viptop3{
                position:relative;
                cursor:pointer;
                width: 376px;
                height: 100px;
                opacity: 1;
                margin-right:45px;
                // background:url('./images/vip_hj_bg.png') no-repeat;
                background-size: 100% 100%;
                display:flex;
                justify-content: flex-start;
                align-items:center;
                .vipcont-3{
                    width:71px;
                    height:83px;
                    margin-left:25px;
                    margin-top:13px;
                }
                &>span{
                    font-size: 38px;
                    font-family: PingFang SC, PingFang SC-Semibold;
                    font-weight: 600;
                    margin-left:9px;
                    color: #7a4f2d;
                    padding-right:21px;
                    margin-right:29px;
                    border-right:1px solid #cacaca;
                }
            }
        }
    }
    .vipFooter{
        height: 80px;
        opacity: 1;
        background: #ffffff;
        box-shadow: 0px -3px 15px 0px rgba(0,0,0,0.15);
        .vipbtn{
            width: 150px;
            height: 44px;
            opacity: 1;
            background: #ffd800;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            color: #000000;
            border:none;
            outline:none;
            text-align: center;
            cursor:pointer;
        }
        .vipFooterContent{
            width:1334px;
            margin:0 auto;
            display: flex;
            justify-content: space-between;
            .vipFooter1{
                display: flex;
                flex-direction: column;
                span:first-child{
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #999999;
                    margin-top:15px;
                    margin-bottom:10px;
                }
                span:last-child{
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #000000;
                }
            }
            .vipFooter2{
                display:flex;
                justify-content: flex-start;
                align-items: center;
                height:80px;
                .vipFooter2_1{
                    display: flex;
                    flex-direction: column;
                    i{
                        font-size: 14px;
                        font-family: PingFang SC, PingFang SC-Semibold;
                        font-weight: 600;
                        color: #000000;
                        font-style:normal
                    }
                    span:first-child{
                        font-size: 14px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        color: #666666;
                        margin-bottom:10px;
                    }
                    span:last-child{
                        font-size: 14px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        color: #000000;
                    }
                }
            }
        }
        
    }
    .viptit3{
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        img{
            width:24px;
            height:24px;
            margin-right:16px;
            cursor: pointer;
        }
        span{
            font-size: 18px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            text-align: LEFT;
            color: #f96509;
        }
    }
    .tempimg{
        display:none;
        position:absolute;
        right:0;
        bottom:0;
        width:50px;
        height:36px;
    }
    .vipSelect{
        box-shadow: 0px 4px 15px 0px rgba(0,0,0,0.25); 
        .tempimg{
            display:block;
        }
    }
    .vipmiddle{
        // display:flex;
        justify-content: flex-start;
        align-items: center;
    }
    .vipmiddle1{
        width: 359px;
        height: 84px;
        opacity: 1;
        background: #fffdf3;
        border: 1px solid #ffd800;
        border-radius: 13px;
        position:relative;
        display:flex;
        float: left;
        align-items: center;
        margin-left: 12px;
        margin-right:48px;
        margin-bottom: 20px;
        .vipmiddleimg{
            width:24px;
            height:24px;
            position:absolute;
            left:-13px;
            top:30px;
            background:#fff;
            cursor: pointer;
        }
        .vipmiddlep{
            width: 150px;
            text-align: center;
            margin-right: 10px;
            border-right: 1px solid rgba(255, 216, 0, 0.3);
            .fh{
                font-size: 20px;
                font-family: Source Han Sans CN, Source Han Sans CN-Heavy;
                font-weight: 800;
                color: #f96509;
                margin-left:13px;
                margin-top:23px;
                margin-right:3px;
            }
            .price{
                font-size: 30px;
                font-family: Source Han Sans CN, Source Han Sans CN-Bold;
                font-weight: 700;
                text-align: LEFT;
                color: #f96509;
            }
            .discount_text{
                margin-left:3px;
                font-size: 20px;
                font-family: Source Han Sans CN, Source Han Sans CN-Heavy;
                font-weight: 800;
                color: #f96509;
                margin-top:23px;
            }
        }
        .vipmiddleb{
            display:flex;
            flex-direction: column;
            align-items: center;
            span:first-child{
                font-size: 14px;
                font-family: Source Han Sans CN, Source Han Sans CN-Bold;
                font-weight: 700;
                color: #282828;
                margin-bottom:6px;
            }
            span:last-child{
                font-size: 12px;
                font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                font-weight: 400;
                color: #999999;
            }
        }
    }
    .viptwo{
        width:1334px;
        margin:0 auto;
        .viptitle{
            margin-top:48px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            color: #000000;
            margin-bottom:10px;
        }
        .viptwocontent{
            width: 1334px;
            height: 224px;
            opacity: 1;
            border: 1px solid #e5e5e5;
            border-radius: 7px;
            display:flex;
            flex-direction: column;
            align-items: flex-start;
            padding-left:29px;
            padding-top:34px;
            .viptwocontentp{
                display:flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom:14px;
                p:first-child{
                    width: 70px;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #666666;
                    text-align:left;
                }
                p:last-child{
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Semibold;
                    font-weight: 600;
                    color: #000000;
                    margin-left:28px;
                }
            }
        }
        .vipBtocontent{
            display:flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom:32px;
            .vipactiv{
                border:2px solid #ffd800 !important;
            }
            .viptwocob{
                width: 211px;
                height: 65px;
                opacity: 1;
                border: 1px solid #e5e5e5;
                border-radius: 7px;
                margin-right:32px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .viptwocob1{
                    width:35px;
                    height:35px;
                    margin-left:32px;
                }
                .viptwocob2{
                    display: flex;
                    flex-direction: column;
                    margin-left:15px;
                    p:first-child{
                        font-size: 14px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        color: #000000;
                        a{
                            width: 50px;
                            height: 18px;
                            display: inline-block;
                            background: #ffd800;
                            border-radius: 9px;
                            color: #000000;
                            line-height: 18px;
                            text-align: center;
                            font-size:12px;
                            -webkit-transform:scale(0.84);
                            margin-left: 6px;
                            &:hover{
                                box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.12); 
                            }
                        }
                    }
                    p:last-child{
                        font-size: 12px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        color: #999999;
                        margin-top:2px;
                    }
                }
            }
        }   
    }
    .vipTwoFooter{
        height:160px;
        border-top:1px solid #e5e5e5;
        display: flex;
        justify-content: flex-end;
        div:first-child{
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: #666666;
            margin-top:57px;
            margin-right:4px;
        }
        .tempdif{
            font-size: 28px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            text-align: LEFT;
            color: #f96509;
            margin-top:42px;
            margin-right:62px;
        }
    }
    .vipbtn{
        width: 150px;
        height: 44px;
        opacity: 1;
        background: #ffd800;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: #000000;
        border:none;
        outline:none;
        text-align: center;
        cursor:pointer;
    }
    .mydiag{
        position:fixed;
        top:0px;
        bottom:0px;
        left:0px;
        right:0px;
        margin:auto;
        background:rgba(0,0,0,0.25);
        .mydiag_content{
            position:absolute;
            top:0px;
            bottom:0px;
            left:0px;
            right:0px;
            margin:auto;
            width:468px;
            height:566px;
            background: #ffffff;
            border-radius: 8px;
            .mydiag_title{
                height:85px;
                border-bottom:1px solid #ececec;
                display: flex;
                justify-content: space-between;
                align-items: center;
                div{
                    font-size: 16px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    margin-left:30px;
                    color: #323232;
                }
                img{
                    width:18px;
                    height:18px;
                    margin-right:30px;
                    cursor:pointer;
                }
            }
            .mydiag_img{
                display:flex;
                flex-direction: column;
                align-items: center;
                .mydiag_img1{
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #323232;
                    margin-top:62px;
                    margin-bottom:28px;
                }
            }
        }
    }
    .vipbtn1{
        width: 200px;
        height: 37px;
        opacity: 1;
        background: #ffd800;
        border-radius: 21px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: #4e4e4e;
        border:none;
        outline:none;
        text-align: center;
        cursor:pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .vipthree{
        width: 1334px;
        height: 471px;
        opacity: 1;
        border: 1px solid #e5e5e5;
        border-radius: 7px;
        margin: 0 auto;
        text-align:center;
        margin-bottom:150px;
        img{
            width:250px;
            height:250px;
            margin-top:16px;
        }
        p{
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            text-align: CENTER;
            color: #000000;
            margin-top:12px;
            margin-bottom:28px;
        }
        div{
            display:flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>